import { render, staticRenderFns } from "./contactTab.vue?vue&type=template&id=9609fcf0&scoped=true&"
import script from "./contactTab.vue?vue&type=script&lang=js&"
export * from "./contactTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9609fcf0",
  null
  
)

export default component.exports